import { FC } from 'react';
import { CreateNftContainer } from 'modules/layout/containers/CreateNftContainer';

export const CreateNft: FC = () => <CreateNftContainer />;
